import { Box, Modal } from "@mui/material";
import Text from "components/atoms/text";
import Loader from "components/molecules/loader";
import { AccessbilityViewHeight, useNav } from "context/navContext";
import { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import { device, isTab } from "utils/helperFunctions";
import { XIconBlack } from "utils/iconList";
import { getSessionStorage, setSessionStorage } from "utils/storageUtil";

const defaultAgeRestrictionPromptData = {
  Title: "Before continuing, please verify your age",
  SubTitle: "You need to be 21 years or above for alcohol purchases",
  Description:
    "Products listed in this section are exclusively offered by\nlicensed duty-free outlet (Licensee) and operator of the Platform\nmerely acts as a collection agent of the Licensee\nI declare that I am above the prescribed age limit to purchase\nalcoholic beverages in the State of Karnataka. I also understand\nthat sale of alcoholic beverages by the duty-free Licensee is\nsubject to mandatory physical verification of certain documents,\nincluding passport and boarding pass, and other applicable laws.\nWe retain the right to report accounts that do not adhere to the\nabove mentioned condition.",
  successCtaLabel: "I am above 21",
  failureCtaLabel: "Cancel",
  createdAt: "2025-02-19T10:05:53.022Z",
  updatedAt: "2025-02-19T11:42:49.085Z",
  publishedAt: null,
  Images: {
    data: [
      {
        id: 2707,
        attributes: {
          name: "DisclaimerImage.svg",
          alternativeText: null,
          caption: null,
          width: 231,
          height: 193,
          formats: null,
          hash: "Disclaimer_Image_d542e1955d",
          ext: ".svg",
          mime: "image/svg+xml",
          size: 1.98,
          url: "https://d10sbcma66shuy.cloudfront.net/strapi-assets/Disclaimer_Image_d542e1955d.svg",
          previewUrl: null,
          provider: "strapi-provider-upload-aws-s3-advanced",
          provider_metadata: null,
          createdAt: "2025-02-19T10:05:40.996Z",
          updatedAt: "2025-02-19T10:05:40.996Z",
        },
      },
    ],
  },
};

function DisclaimerPrompt(props) {
  const { accessibilityMode } = useNav();

  const [isLoading, setIsLoading] = useState(false);
  const [displayData, setDisplayData] = useState({});

  useEffect(() => {
    getDisplayData();
  }, []);

  const getDisplayData = () => {
    const data = getSessionStorage("configData");
    if (data?.ageRestrictionPromptData) {
      setDisplayData(data.ageRestrictionPromptData);
    } else {
      setDisplayData(defaultAgeRestrictionPromptData);
    }
  };

  const onSuccess = (e) => {
    setSessionStorage("isAgeDeclared", true);
    props.setIsDrawerOpen(false);
    props.successHandler(e);
  };

  function formatDescription(text) {
    return text?.replace(/\\n/g, "\n");
  }

  const style = {
    position: "absolute",
    top: accessibilityMode ? "80vh" : "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isTab() ? "calc(100% - 60px)" : "954px",
    maxHeight: accessibilityMode ? AccessbilityViewHeight : "unset",
    overflowY: accessibilityMode ? "auto" : "unset",
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    borderRadius: 3,
  };

  return (
    <Modal
      open={props.isDrawerOpen}
      onClose={() => props.setIsDrawerOpen(false)}
    >
      <Box sx={style}>
        {isLoading ? (
          <Loader />
        ) : (
          <ContentWrapper>
            <CancelButtonWrapper>
              <CancelImageButton
                onClick={() => props.setIsDrawerOpen(false)}
                src={XIconBlack}
              />
            </CancelButtonWrapper>
            <TitleText style={props.titleTextStyle}>
              <Text type="bold">{displayData?.Title}</Text>
            </TitleText>
            <SubTitleText style={props.subTitleTextStyle}>
              <Text>{displayData?.SubTitle}</Text>
            </SubTitleText>
            {/* <ImageContainer>
            <Image src={DisclaimerImage} />
            </ImageContainer> */}
            <Description>
              <Text>
                {displayData?.Description && formatDescription(displayData?.Description)?.split("\n")?.map(
                  (line, index) => (
                     <Text key={index}>{line}</Text>
                  )
                )}
              </Text>
            </Description>
            <FooterWrapper>
              <FailureButton
                style={props.failureButtonStyle}
                onClick={() => props.setIsDrawerOpen(false)}
              >
                <Text
                  type="extra-bold"
                  style={{
                    color: "var(--primary)",
                    fontSize: "20px",
                    fontWeight: 800,
                    lineHeight: "21px",
                  }}
                >
                  {displayData?.failureCtaLabel}
                </Text>
              </FailureButton>
              <SuccessButton
                style={props.successButtonStyle}
                onClick={onSuccess}
              >
                <Text
                  type="extra-bold"
                  style={{
                    color: "#fff",
                    fontSize: "20px",
                    fontWeight: 800,
                    lineHeight: "21px",
                  }}
                >
                  {displayData?.successCtaLabel}
                </Text>
              </SuccessButton>
            </FooterWrapper>
          </ContentWrapper>
        )}
      </Box>
    </Modal>
  );
}

const ContentWrapper = styled.div`
  background: linear-gradient(
    180deg,
    hsl(var(--primary-hsl) / 0.2) 28.78%,
    #fff 88.17%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 24px;
  border-radius: 12px;

  @media ${device.tablet} {
    padding: 40px 48px;
  }
`;
const CancelButtonWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 14px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CancelImageButton = styled.img`
  width: 20px;
  height: 20px;
`;
const TitleText = styled.div`
  color: var(--text-primary);
  font-size: 28px;
  font-weight: 700;
  line-height: 23px;
  text-align: center;
  padding: 0px 22px;
`;
const SubTitleText = styled.div`
  color: var(--text-primary);
  font-size: 20px;
  font-weight: 400;
  line-height: 21px;
  margin-top: 8px;
  text-align: center;
  padding: 8px 22px 0px 22px;
`;
const Description = styled.div`
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  opacity: 0.6;
  margin-top: 30px;
  max-height: 300px;
  overflow-y: scroll;
  scrollbarWidth: none;
  text-align: center;

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
    scrollbar-width: none;
  }
`;
const FooterWrapper = styled.div`
  width: 100%;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 30px;
`;
const SuccessButton = styled.div`
  display: flex;
  height: 47px;
  padding: 16px 32px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: var(--primary);

  @media ${device.mobileS} {
    font-size: 12px;
    line-height: 16px;
  }

  @media ${device.mobileL} {
    font-size: 16px;
    line-height: 21px;
  }
`;
const FailureButton = styled.div`
  display: flex;
  height: 47px;
  padding: 16px 32px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--primary);
  min-width: 80px;

  color: var(--primary);
  font-size: 18px;
  font-weight: 800;
  line-height: 21px;

  @media ${device.mobileS} {
    font-size: 12px;
    line-height: 16px;
  }

  @media ${device.mobileL} {
    font-size: 16px;
    line-height: 21px;
  }
`;

export default DisclaimerPrompt;
